<template>
  <div id="boardInfo">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>我的展位</el-breadcrumb-item>
      <el-breadcrumb-item>标准展位</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="formBox" :span="24">
      
      <el-form style="margin-top: 30px; width:50%;" :model="ruleForm" ref="boardForm" label-position="right" label-width="160px">
        <div style="padding-bottom:6px;padding-left:38px;font-size:14px;font-weight:bold">会刊信息中的公司中英文名称将用于楣板名称</div>
        <template v-for="(item,ind) in allList">
          <template>

            <el-form-item :label="item.fieldName" :key="ind" :prop="item.fieldKey" >
            <template v-if="item.fieldKey == 'clgBoardExt1'">
              <el-input v-model="ruleForm[item.fieldKey]"  @keyup.native="inputChange($event,item.fieldKey)" disabled></el-input>
            </template>
            <template v-else>
              <el-input v-model="ruleForm[item.fieldKey]"  disabled></el-input>
            </template>
            </el-form-item>
          </template>
        </template>
        <el-form-item>
          <!-- <el-button type="primary" :style="buttonStyle" @click="submitForm" :disabled = 'saveBtnStatue'>保存</el-button> -->
        </el-form-item>
      </el-form>
    </div>
    
    <div style='margin:20px 0;font-size:16px;font-weight:bold'>手册下载</div>
    <div style="padding:0px 0 10px">
      <el-button type="primary"><a :href="file0" style="font-size:14px;color:#fff;text-decoration:none;"  target="_blank">CAC2025 参展商指南</a></el-button>
      <el-button type="primary"><a :href="file1" style="font-size:14px;color:#fff;text-decoration:none;"  target="_blank" >标准展位参展商须知</a></el-button>
      <el-button type="primary"><a :href="file2" style="font-size:14px;color:#fff;text-decoration:none;" target="_blank" >CAC2025 搭建商服务手册</a></el-button>
      <el-button type="primary"><a :href="file3" style="font-size:14px;color:#fff;text-decoration:none;"  target="_blank" >CAC2025 参展展品（国内）运输指南</a></el-button>
    </div>

    <div style="padding-bottom:100px;margin-top:10px">
      <el-table
        :data="tableData"
        stripe
        style="width: 100%">
        <el-table-column
          prop="text1"
          width='210'
          label="重要事项"
         >
        </el-table-column>
        <el-table-column
          prop="text2"
          label="事项说明"
          >
        </el-table-column>
        <el-table-column
          prop="text3"
          width="190"
          label="截止日期">
        </el-table-column>
        <el-table-column prop="more" label="更多详情" align="center" width="190">
          <template slot-scope="scope">
            <el-button type="primary" style="width:160px" v-if="scope.row.more =='点击填写'" @click="toLink(scope.row.address)">{{scope.row.more}}</el-button>
            <el-button type="primary" style="width:160px" v-else><a :href="scope.row.address" style="font-size:14px;color:#fff;text-decoration:none;" target="_blank" >{{scope.row.more}}</a></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import api from '@/api'
import tools from '../../utils/tools.js';
import img01 from '@/assets/img01.png'
import img02 from '@/assets/img02.png'
import img03 from '@/assets/img03.png'
export default {
  name: 'boardInfo',
  data () {
    return {
      msg: '',
      allList:[],
      rulesData: {},
      ruleForm: {
        clgID: 0
      },
      file0:'./CAC2025参展商指南－中文版.pdf',
      file1:'./标准展位参展商须知.pdf',
      file2:'./CAC2025 搭建商手册.docx',
      file3:'./CAC2025 参展展品（国内）运输指南.docx',
      saveBtnStatue: false,
      buttonStyle: sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {},
      img01:img01,
      img02:img02,
      img03:img03,
      tableData:[
        {
          text1:"电子会刊、楣板及展商名录",
          text2:"在“公司信息”模块下“电子会刊信息”中提交的名称将用于楣板制作及现场展商名录",
          text3:"会刊截止：2025年2月20日",
          more:'点击填写',
          type:'',
          address:'/magezine'
        },
        {
          text1:"参展证",
          text2:"在“参展证申请”模块下提交参展人员信息用于制作参展证件",
          text3:"2025年3月16日",
          more:'点击填写',
          type:'',
          address:'/card'
        },
        {
          text1:"展位配置",
          text2:"关于展板、地毯、展位配置设施的说明",
          text3:"2025年3月16日",
          more:'点击查看下载文档',
          type:'file',
          address:'./标准展位配置.pdf'
        },
        {
          text1:"标改特搭建申请",
          text2:"禁止18平米以下展位自行改建或搭建特装，如企业需要进行特殊搭建，请进入主场搭建服务平台申报",
          text3:"2025年1月22日",
          more:'点击申请链接',
          type:'url',
          address:'http://CAC.best-expo.com.cn'
        },
        {
          text1:"电箱、家具租赁申请",
          text2:"请登录主场搭建服务平台对电箱、家具租赁进行申报，展会现场主场搭建服务商将不再提供家具租赁服务",
          text3:"2025年1月22日",
          more:'点击申请链接',
          type:'url',
          address:'http://CAC.best-expo.com.cn'
        },
        {
          text1:"车辆进馆轮候证及车证办理",
          text2:"在展馆北登录厅主场运输服务台办理停车场轮候证（30元/证/次），领取标展进馆凭证，前往NH馆（北大厅二楼）制证中心办理装卸区车辆通行证和装卸区车辆引导证",
          text3:"2025年3月15-16日",
          more:'点击查看下载文档',
          type:'file',
          address:'./标展车辆进馆轮候证及车证办理.pdf'
        }
      ]
    }
  },
  mounted() {
    this.getsaasfield()
  },
  methods: {
    //禁止input输入 数字以外的字符
    inputChange(ev,val){
      this.ruleForm[val] = this.ruleForm[val].replace(/[^\d]/g,'');
    },
    rulesFn(item){
      var temp = ''
      var rulesData= {
        other:{required:item.required, message: item.fieldName+'不能为空', trigger: 'change'}
      }
      switch (item.fieldKey){
        case 'ClgBoard':
        case 'ClgEBoard':
        case 'ClgBoardExt1':
          temp = 'other'
          break;
        default: 
          temp = 'other'
          break
      }
      return rulesData[temp]
    },
    getsaasfield(){
      api.getsaasfield({type:"lintel"}).then(res => {
        if (res.data.code === 200) {
           this.allList =[]
            var _data = res.data.data
          for(var i = 0;i<_data.length;i++){
            if(_data[i].enable == 1){
              this.allList.push(_data[i])
            }
          }
          for(var j=0;j<this.allList.length;j++){
            this.$set( this.ruleForm,this.allList[j].fieldKey,"")
          }
          this.$nextTick(() => {
            this.getlinteldetail()
          })
        }
      })
    },
    getlinteldetail() {
      api.getlinteldetail(this.ruleForm).then(res => {
        if (res.data.code === 200) {
          for (var item in this.ruleForm) {
            if (res.data.data[item]) {
              this.ruleForm[item] = res.data.data[item]
            }
          }
        }
      })
    },
    submitForm(formName) {
      this.$refs.boardForm.validate((valid) => {
        if (valid) {
          api.savelintel(this.ruleForm).then(res => {
            if (res.data.code === 200) {
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success'
              });
            }
          })
        } else {
          this.$notify({
            title: '请检查表单填写项是否符合规范！',
            type: 'error'
          })
          return false;
        }
      })
    },
    toLink(str){
      this.$router.push(str)
    }
  }
}
</script>
<style lang="less">
#boardInfo{
  font-size:14px;
  .form{
    width: 50%;
    margin-top:20px;
  }
  .tips{
    padding: 20px 0;
    font-size: 14px;
    line-height: 20px;
  }
  .msg{
    padding-top: 20px;
    font-size: 14px;
    line-height: 20px;
    width: 50%;
    h3{
      font-size: 14px;
      padding-bottom: 10px;
    }
    p{
      padding:4px 0
    }
  }
  @media screen and (max-width:540px){
    .el-form-item__content{
      width: 240px;
    }
    .btns{
      text-align: center;
    }
  }
}
</style>

